import type { UnmatchedResponse } from "./apiTypes";
import { formatManilaWindow } from "./countdown";

function appendText(parent: HTMLElement, tagName: keyof HTMLElementTagNameMap, text: string, className?: string): HTMLElement {
  const element = document.createElement(tagName) as HTMLElement;
  element.textContent = text;
  if (className) {
    element.className = className;
  }
  parent.appendChild(element);
  return element;
}

function appendExternalLink(parent: HTMLElement, url: string): void {
  const link = document.createElement("a");
  link.href = url;
  link.textContent = "Source Facebook post";
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  parent.appendChild(link);
}

export function renderUnmatchedPanel(container: HTMLElement, response: UnmatchedResponse): void {
  container.textContent = "";
  const section = document.createElement("section");
  section.className = "unmatched-panel";
  appendText(section, "h2", "Updates we could not place on the map");

  if (response.items.length === 0) {
    appendText(section, "p", "No unmatched updates.", "muted");
    container.appendChild(section);
    return;
  }

  const list = document.createElement("ol");
  list.className = "unmatched-list";
  for (const item of response.items) {
    const row = document.createElement("li");
    appendText(row, "p", item.rawText || item.areaText, "raw-update");
    const strippedRaw = item.rawText.replace(/^\s*WHERE:\s*/i, "").trim();
    if (item.areaText && item.areaText.trim() !== strippedRaw) {
      appendText(row, "p", item.areaText, "area-text");
    }
    if (item.window) {
      appendText(row, "p", formatManilaWindow(item.window), "feed-window");
    }
    if (item.parserWarnings.length > 0) {
      appendText(row, "p", `Parser warnings: ${item.parserWarnings.join(", ")}`, "warning-text");
    }
    if (item.postUrl) {
      const linkRow = document.createElement("p");
      appendExternalLink(linkRow, item.postUrl);
      row.appendChild(linkRow);
    }
    list.appendChild(row);
  }
  section.appendChild(list);
  container.appendChild(section);
}
